import { BaseModel } from "sjs-base-model";
import ProductsModel from "../../models/products/ProductsModel";
import SubscriptionModel from "../../models/subscription/SubscriptionModel";
import ModulePricingLevelModel from "../../models/modulePricing/ModulePricingLevelModel";
import configuration from "../../utilities/configuration";
import * as EffectUtility from "../../utilities/EffectUtility";

export async function requestProducts() {
    const endpoint = configuration.apiServer + configuration.apiProductsInfo;
    return EffectUtility.getToModel(ProductsModel, endpoint, {}, false);
}

export async function editProduct(productId, config) {
    const endpoint = configuration.apiServer + configuration.apiProductsInfo + "/" + productId;
    return EffectUtility.putToModel(BaseModel, endpoint, config);
}

export async function requestProductSubscriptionTypes(productId) {
    const endpoint = configuration.apiServer + configuration.apiProductsInfo + "/" + productId + "/subscriptionTypes";
    return EffectUtility.getToModel(SubscriptionModel, endpoint);
}

export async function requestProductModulePricingLevels(productId) {
    const endpoint = configuration.apiServer + configuration.apiProductsInfo + "/" + productId + "/modulePricingLevels";
    return EffectUtility.getToModel(ModulePricingLevelModel, endpoint);
}
